module.exports = __webpack_public_path__ + "img/392307_B3AE7D_6D5618_847C42-256px.3b160b89.png";